import React from "react";
import { Redirect, Route } from "react-router-dom";
import { useAppAuth } from "./app-auth";

const ProtectedRoute = ({ component: Component, requiredRole, ...args }) => {
  const { isAuthenticated, isLoading, user } = useAppAuth();

  return (
    <Route
      {...args}
      render={(routeProps) => {
        if (isLoading) {
          return <div>Application is Loading</div>;
        }

        if (!isAuthenticated) {
          return <Redirect to="/" />;
        }

        if (requiredRole && user?.role !== requiredRole) {
          return <Redirect to="/dashboard" />;
        }

        return <Component {...routeProps} />;
      }}
    />
  );
};

export default ProtectedRoute;
